import { configureStore } from "@reduxjs/toolkit";
import addressReducer from "../redux/address/addressSlice";
import authReducer from "../redux/auth/authSlice";
import authOptReducer from "../redux/auth/otpSlice";
import blogReducer from "../redux/blog/blogSlice";
import blogDetailReducer from "../redux/blogDetails/blogDetailsSlice";
import cartReducer from "../redux/cart/cartSlice";
import categoriesReducer from "../redux/categories/categoriesSlice";
import searchReducer from "../redux/filter/searchSlice";
import happyclientReducer from "../redux/happyClient/happyClientSlice";
import homeReducer from "../redux/home/homeSlice";
import orderListReducer from "../redux/orderList/orderList";
import categoryListReducer from "../redux/products/categorySlice";
import productDetailReducer from "../redux/products/productDetails";
import subcategorylistReducer from "../redux/products/subCategorySlice";
import userProfileReducer from "../redux/userProfile/userProfile";
import orderdetailReducer from "../redux/orderList/oderDetailsData";
import languageReducer from "../redux/language/languageSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    authotp: authOptReducer,
    home: homeReducer,
    categorylist: categoryListReducer,
    subcategorylist: subcategorylistReducer,
    cart: cartReducer,
    search: searchReducer,
    address: addressReducer,
    categories: categoriesReducer,
    orderList: orderListReducer,
    userProfile: userProfileReducer,
    productDetail: productDetailReducer,
    blogs: blogReducer,
    blogDetail: blogDetailReducer,
    happyclient: happyclientReducer,
    orderdetail: orderdetailReducer,
    language: languageReducer,
  },
});
